import React from 'react'

const WorksItems = ({item}) => {
  return (
    <div className="work__card" key={item.id}>
        <img src={item.image} alt='' className='work__img'/>
        <h3 className="work__title">{item.title}</h3>
        <a href={item.proyect}  className="work__button">Go</a>
        <a href={item.github}  className="work__button">Github</a>

    </div>
  )
}

export default WorksItems